import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 40,
    marginRight: 32,
  },
  year: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  decrease: {
    marginRight: 4,
  },
  increase: {
    marginLeft: 4,
  },
}));
